module.exports = __webpack_public_path__ + "img/vision.d8c53d0e.png";